module.exports = __webpack_public_path__ + "assets/images/Order_Type_P_Icon.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/Order_Type_P_Icon.png
// module id = 1425
// module chunks = 1